

//cgi配置
var daoConfig = {
    'checkLogin': {
        url: '/login?action=checkLogin',
        method: 'get'
    },
    'quitLogin': {
        url: '/login?action=quitLogin',
        method: 'get'
    },
    'queryRegion': {
        url: '/com?action=queryRegion',
        method: 'get'
    },
    'queryCorpRedirect': {
        url: '/com?action=queryCorpRedirect',
        method: 'get'
    },
    'queryWhiteList': {
        url: '/com?action=getWhiteList',
        method: 'post'
    },
    'getUserData': {
        url: '/com?action=getUserData',
        method: 'post'
    },
    'queryOs': {
        url: '/cvm?action=queryOS',
        method: 'get'
    },
    'queryCdnMenu': {
        url: '/com?action=queryCdnMenu',
        method: 'get'
    },
    'queryYunsoMenu': {
        url: '/com?action=queryYunsoMenu',
        method: 'get'
    },
    'queryWenzhiMenu': {
        url: '/com?action=queryWenzhiMenu',
        method: 'get'
    },
    'queryMonitorMenu': {
        url: '/com?action=queryMonitorMenu',
        method: 'get'
    },
    'queryCpayMenu': {
        url: '/com?action=queryCpayMenu',
        method: 'get'
    },
    'getUserIsSeeGuidelines': {
        url: '/com?action=getUserIsSeeGuidelines',
        method: 'get'
    },
    'setUserIsSeeGuidelines': {
        url: '/com?action=setUserIsSeeGuidelines',
        method: 'post'
    },
    'getUserGuideData': {
        url: '/com?action=getUserGuideData',
        method: 'get'
    },
    'setUserGuideData': {
        url: '/com?action=setUserGuideData',
        method: 'post'
    },
    'getMsgList': {
        url: '/message?action=getMsgList',
        method: 'get'
    },
    'getTicketNum': {
        url: '/com?action=getTicketNum',
        method: 'get'
    },
    'getVouchersNum': {
        url: '/com?action=getVouchersNum',
        method: 'get'
    },
    'getCVMNotice': {
        url: '/cvm?action=getNotice',
        method: 'get'
    },
    'payByCartCvm': {
        url: '/cvm?action=payByCartCvm',
        method: 'post'
    },
    'getCvmList': {
        url: '/cvm?action=getCvmList',
        method: 'get'
    },
    'getCvmMore': {
        url: '/cvm?action=getCvmMore',
        method: 'get'
    },
    'getFlowCscResult': {
        url: '/com?action=getFlowCscResult',
        method: 'get'
    },
    'rebootCvm': {
        url: '/cvm?action=rebootCvm',
        method: 'post'
    },
    'cvmAction': {
        url: '/cvm?action=cvmAction',
        method: 'post'
    },
    'modifyCvmAliasBatch': {
        url: '/cvm?action=modifyCvmAliasBatch',
        method: 'post'
    },
    'resetCvmSystem': {
        url: '/cvm?action=resetCvmSystem',
        method: 'post'
    },
    'switchCvmSystem': {
        url: '/cvm?action=switchCvmSystem',
        method: 'post'
    },
    'getQuotiesChargeItem': {
        url: '/cvm?action=getQuotiesChargeItem',
        method: 'post'
    },
    'resetCvmPasswd': {
        url: '/cvm?action=resetCvmPasswd',
        method: 'post'
    },
    'formatCvmDisk': {
        url: '/cvm?action=formatCvmDisk',
        method: 'post'
    },
    'getBandwidthHistory': {
        url: '/cvm?action=getBandwidthHistory',
        method: 'get'
    },
    'getPrice': {
        url: '/cvm?action=getPrice',
        method: 'post'
    },
    'getPriceForHour': {
        url: '/cvm?action=getPriceForHour',
        method: 'get'
    },
    'getBandwidthReturnFittingPrice': {
        url: '/cvm?action=getBandwidthReturnFittingPrice',
        method: 'get'
    },
    'upgradeHourCvm': {
        url: '/cvm?action=upgradeHourCvm',
        method: 'post'
    },
    'upgradeHourCvmBandwidth': {
        url: '/cvm?action=upgradeHourCvmBandwidth',
        method: 'post'
    },
    'returnCvm': {
        url: '/cvm?action=returnCvm',
        method: 'post'
    },
    'canPrepaidReturn': {
        url: '/cvm?action=getReturnResourcesPrice',
        method: 'post'
    },
    'verifyCode': {
        url: '/cvm?action=verifyCode',
        method: 'post'
    },
    'destroyCvm': {
        url: '/cvm?action=destroyCvm',
        method: 'post'
    },
    'destroyCvmAndCdhCvm': {
        url: '/cvm?action=destroyCvmAndCdhCvm',
        method: 'post'
    },
    'restoreCdhCvm': {
        url: '/cdh?action=restoreCdhCvm',
        method: 'post'
    },
    'returnCvmInTime': {
        url: '/cdh?action=returnCvmInTime',
        method: 'get'
    },
    'getCdhChartData': {
        url: '/cdh?action=getCdhChartData',
        method: 'get'
    },
    'getCdhMonitorChartData': {
        url: '/cdh?action=getCdhMonitorChartData',
        method: 'get'
    },
    'getStatisticsGridData': {
        url: '/cdh?action=getStatisticsGridData',
        method: 'get'
    },
    'getCdhChartDataBatch': {
        url: '/cdh?action=getCdhChartDataBatch',
        method: 'get'
    },
    'getRealTimeCdhData': {
        url: '/cdh?action=getRealTimeCdhData',
        method: 'get'
    },
    'upgradeXenToKvm': {
        url: '/cvm?action=upgradeXenToKvm',
        method: 'post'
    },

    'getImageCategories': {
        url: '/cvm?action=getImageCategories',
        method: 'get'
    },
    'getMarketWhiteList': {
        url: '/cvm?action=getMarketWhiteList',
        method: 'get'
    },
    'checkResetSys': {
        url: '/cvm?action=checkResetSys',
        method: 'get'
    },
    'getImageProductsDetail': {
        url: '/cvm?action=getImageProductsDetail',
        method: 'get'
    },
    'getImagesDetail': {
        url: '/cvm?action=getImagesDetail',
        method: 'get'
    },

    'setBandwidthLimit': {
        url: '/cvm?action=setBandwidth',
        method: 'post'
    },
    'setBandwidthLimitForFlow': {
        url: '/cvm?action=setBandwidthLimitForFlow',
        method: 'post'
    },
    'changeProject': {
        url: '/cvm?action=changeProject',
        method: 'post'
    },
    'setRenewFlag': {
        url: '/cvm?action=setRenewFlag',
        method: 'post'
    },
    'queryKeypair': {
        url: '/sshkey?action=queryKeypair',
        method: 'get'
    },
    'createKeypair': {
        url: '/sshkey?action=createKeypair',
        method: 'post'
    },
    'loadKeypair': {
        url: '/sshkey?action=loadKeypair',
        method: 'post'
    },
    'modifyKeypair': {
        url: '/sshkey?action=modifyKeypair',
        method: 'post'
    },
    'deleteKeypair': {
        url: '/sshkey?action=deleteKeypair',
        method: 'post'
    },
    'manageCvmKey': {
        url: '/sshkey?action=manageCvmKey',
        method: 'post'
    },
    'detailKeypair': {
        url: '/sshkey?action=detailKeypair',
        method: 'get'
    },
    'loadChartData': {
        url: '/cvm?action=loadChartData',
        method: 'get'
    },
    'getMonitorAgent': {
        url: '/cvm?action=getMonitorAgent',
        method: 'get'
    },
    'queryKeyByIps': {
        url: '/cvm?action=queryKeyByIps',
        method: 'get'
    },
    'queryCvmOpLogs': {
        url: '/cvm?action=queryCvmOpLogs',
        method: 'get'
    },
    'getServiceAccount': {
        url: '/com?action=getServiceAccount',
        method: 'get'
    },
    'getAccounts': {
        url: '/com?action=getAccounts',
        method: 'get'
    },
    'createCvmImage': {
        url: '/image?action=createCvmImage',
        method: 'post'
    },
    'queryImages': {
        url: '/image?action=getCvmImageInfo',
        method: 'get'
    },
    'delImages': {
        url: '/image?action=deleteCvmImage',
        method: 'post'
    },
    'modImage': {
        url: '/image?action=modifyCvmImageInfo',
        method: 'post'
    },
    'queryCbsList': {
        url: '/cbs?action=getCbsList',
        method: 'get'
    },
    'modifyCbsAlias': {
        url: '/cbs?action=modifyCbsAlias',
        method: 'post'
    },
    'setCbsAutoRenewFlag': {
        url: '/cbs?action=setCbsAutoRenewFlag',
        method: 'post'
    },
    'getDashboardBase': {
        url: '/dashboard?action=getDashboardBase',
        method: 'get'
    },
    'getAppMonitor': {
        url: '/dashboard?action=getAppMonitor',
        method: 'get'
    },
    'getAppSecurity': {
        url: '/dashboard?action=getAppSecurity',
        method: 'get'
    },
    'getNetworkFlow': {
        url: '/dashboard?action=getNetworkFlow',
        method: 'get'
    },
    'getMargin': {
        url: '/dashboard?action=getMargin',
        method: 'get'
    },
    'getServicesInfo': {
        url: '/dashboard?action=getServicesInfo',
        method: 'get'
    },
    'getExpireNum': {
        url: '/dashboard?action=getExpireNum',
        method: 'get'
    },
    'getNotice': {
        url: '/dashboard?action=getNotice',
        method: 'get'
    },
    'getVpcList': {
        url: '/vpc?action=getVpcList',
        method: 'get'
    },
    'getVpcRegionWhiteList': {
        url: '/vpc?action=getVpcRegionWhiteList',
        method: 'get'
    },
    'getVpcView': {
        url: '/vpc?action=getVpcView',
        method: 'get'
    },
    'addVpc': {
        url: '/vpc?action=addVpc',
        method: 'post'
    },
    'delVpc': {
        url: '/vpc?action=delVpc',
        method: 'post'
    },
    'modifyVpcProperty': {
        url: '/vpc?action=modifyVPCProperty',
        method: 'post'
    },
    'modifyVPCSubnetRouteTable': {
        url: '/vpc?action=modifyVPCSubnetRouteTable',
        method: 'post'
    },
    'getVpcDeviceCount': {
        url: '/vpc?action=getVpcDeviceCount',
        method: 'get'
    },
    'getSubnetInfo': {
        url: '/subnet?action=getSubnetInfo',
        method: 'get'
    },
    'addSubnet': {
        url: '/subnet?action=addSubnet',
        method: 'post'
    },
    'queryZone': {
        url: '/subnet?action=queryZone',
        method: 'get'
    },
    'getVpcZoneWhiteList': {
        url: '/vpc?action=getVpcZoneWhiteList',
        method: 'get'
    },
    'modifySubnet': {
        url: '/subnet?action=modifySubnet',
        method: 'post'
    },
    'deleteSubnet': {
        url: '/subnet?action=deleteSubnet',
        method: 'post'
    },
    'getVPCGatewayList': {
        url: '/route?action=getVPCGatewayList',
        method: 'get'
    },
    'getVPCRouteTable': {
        url: '/route?action=getVPCRouteTable',
        method: 'get'
    },
    'addVPCRouteTable': {
        url: '/route?action=addVPCRouteTable',
        method: 'post'
    },
    'modifyVPCRouteTable': {
        url: '/route?action=modifyVPCRouteTable',
        method: 'post'
    },
    'deleteVPCRouteTable': {
        url: '/route?action=deleteVPCRouteTable',
        method: 'post'
    },
    'getVpnGw': {
        url: '/vpc?action=getVpnGw',
        method: 'get'
    },
    'initVpnGw': {
        url: '/vpc?action=initVpnGw',
        method: 'post'
    },
    'clearVpnGw': {
        url: '/vpc?action=clearVpnGw',
        method: 'post'
    },
    'clearSslVpn': {
        url: '/sslvpn?action=clearSslVpn',
        method: 'post'
    },
    'getVpnGwQuota': {
        url: '/vpc?action=getVpnGwQuota',
        method: 'get'
    },
    'addVpnGw': {
        url: '/vpc?action=addVpnGw',
        method: 'post'
    },
    'addUserGw': {
        url: '/vpc?action=addUserGw',
        method: 'post'
    },
    'addVpnConn': {
        url: '/vpc?action=addVpnConn',
        method: 'post'
    },
    'getUserGwProperty': {
        url: '/vpc?action=getUserGwProperty',
        method: 'get'
    },
    'getVpnConnProperty': {
        url: '/vpc?action=getVpnConnProperty',
        method: 'get'
    },
    'getVpnStuff': {
        url: '/vpc?action=getVpnStuff',
        method: 'get'
    },
    'modifyVpnGw': {
        url: '/vpc?action=modifyVpnGw',
        method: 'post'
    },
    'delUserGw': {
        url: '/vpc?action=delUserGw',
        method: 'post'
    },
    'modifyUserGw': {
        url: '/vpc?action=modifyUserGw',
        method: 'post'
    },
    'modifyVpnConn': {
        url: '/vpc?action=modifyVpnConn',
        method: 'post'
    },
    'delVpnConn': {
        url: '/vpc?action=delVpnConn',
        method: 'post'
    },
    'getVpnPrice': {
        url: '/vpc?action=getVpnPrice',
        method: 'post'
    },
    'payByCart': {
        url: '/vpc?action=payByCart',
        method: 'post'
    },
    'getDealsByCond': {
        url: '/vpc?action=getDealsByCond',
        method: 'post'
    },
    'getUserGwVendor': {
        url: '/vpc?action=getUserGwVendor',
        method: 'get'
    },
    'loadVpnChartData': {
        url: '/vpc?action=loadVpnChartData',
        method: 'get'
    },
    'getOperatelogList': {
        url: '/operatelog?action=getOperatelogList',
        method: 'get'
    },
    // -------- VPC UI 2.0新增接口 -----------
    'getVpcTopo': {
        url: '/vpctopo?action=getVpcTopo',
        method: 'get'
    },
    'getVpcTopoExternal': {
        url: '/vpctopo?action=getVpcTopoExternal',
        method: 'get'
    },
    getGwStatusList: {
        url: '/vpctopo?action=getGwStatusList',
        method: 'get'
    },
    getVpnGwStatusList: {
        url: '/vpctopo?action=getVpnGwStatusList',
        method: 'get'
    },
    getVpnConnStatusList: {
        url: '/vpctopo?action=getVpnConnStatusList',
        method: 'get'
    },
    'getVpcStatisticList': {
        url: '/vpc?action=getVpcStatisticList',
        method: 'get'
    },
    'getVpcSubnetStatisticList': {
        url: '/vpc?action=getVpcSubnetStatisticList',
        method: 'get'
    },
    // 修改vpc cvm ip
    'updateCvm': {
        url: '/vpc?action=updateCvm',
        method: 'post'
    },
    // vpc、子网，额外获取查询比较慢的列的数据，比如：LB、公网网关计数
    getVpcExternalStatistic: {
        url: '/vpc?action=getVpcExternalStatistic',
        method: 'get'
    },
    getVpcSubnetIpCounts: {
        url: '/vpc?action=getVpcSubnetIpCounts',
        method: 'get'
    },
    // 路由表
    getVpcRtbStatisticList: {
        url: '/vpc?action=getVpcRtbStatisticList',
        method: 'get'
    },
    // VPN网关
    getVpcVpnGwStatisticList: {
        url: '/vpc?action=getVpcVpnGwStatisticList',
        method: 'get'
    },
    getVpcVpnGwStatisticListEx: {
        url: '/vpc?action=getVpcVpnGwStatisticListEx',
        method: 'get'
    },
    // VPN通道
    getVpcVpnConnStatisticList: {
        url: '/vpc?action=getVpcVpnConnStatisticList',
        method: 'get'
    },
    // 对端网关
    getVpcUserGwStatisticList: {
        url: '/vpc?action=getVpcUserGwStatisticList',
        method: 'get'
    },
    // 云api透传接口
    delegateCApi: {
        url: '/capi?action=delegate',
        method: 'post'
    },

    queryConfigureProducts: {
        url: '/datacfg?action=queryConfigureProducts',
        method: 'get'
    },

    updateUserDefined: {
        url: '/datacfg?action=updateUserDefined',
        method: 'post'
    },

    queryConfigureCodeData: {
        url: '/datacfg?action=queryConfigureCodeData',
        method: 'post'
    },

    getSslVpnStatisticListEx: {
        url: '/sslvpn?action=getSslVpnStatisticListEx',
        method: 'get'
    },

    getVpcVpnUsedList: {
        url: '/sslvpn?action=getVpcVpnUsedList',
        method: 'get'
    },

    getDeveloperAccountList: {
        url: '/com?action=getDeveloperAccountList',
        method: 'get'
    },

    switchDeveloperAccount: {
        url: '/com?action=switchDeveloperAccount',
        method: 'post'
    },

    //黑石相关
    resetCpmPasswd: {
        url: '/cpm?action=resetCpmPasswd',
        method: 'post'
    },

    getVpcBmVpnGwList: {
        url: '/vpcbm?action=getVpcBmVpnGwList',
        method: 'get'
    },

    getPriceBm: {
        url: '/cpm?action=getPrice',
        method: 'post'
    },

    generateDeals: {
        url: '/vpcbm?action=generateDeals',
        method: 'post'
    },

    getGroupList: {
        url: '/com?action=getGroupList',
        method: 'get'
    },
    ping: {
        url: '/com?action=ping',
        method: 'get'
    }
};

var host = '/cgi';
if (host) {
    for (var i in daoConfig) {
        var cur = daoConfig[i];
        if (cur && cur.url) {
            cur.url = host + cur.url;
        }
    }
}

var config = {};
config.get = function (argv) {
    return daoConfig[argv];
};

export default config;

